import { trackClientEvent } from '../../../../trackClientEvent';
export var eventKey = 'faire_direct-shoppable_landing_page_nav_sign_up-click';
/**
 * Track the sign up on click in the navbar of the Shoppable Faire Direct Landing Page
 */ export function trackFaireDirectShoppableLandingPageNavSignUpClick() {
    return trackClientEvent({
        eventKey: eventKey,
        realTimeTracking: false
    });
}
